<template>
    <div>
        <p v-if="!successFile">{{downloadingText}}</p>
        <p v-else>{{readyText}}</p>
        <div :ref="'divloading' + keyId" class="modal-body">
            <div class="position-relative">
                <div class="h100">
                    <div class="container h-100">
                        <div class="row h-100 justify-content-center align-items-center">
                            <div class="col-12">
                                <div class="h-100 text-center">
                                    <div class="alert alert-danger" role="alert" v-show="excelError">
                                        <span class="mdi mdi-alert-rhombus-outline"></span> {{errorText}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-btn class="" medium elevation="3" @click="close" v-show="excelError">
            {{$t('common.lblClose')}}
        </v-btn>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        data: function () {
            return {
                excelError: false,
                successFile: false,
                successUrl: '',
                excelTooLarge: false,
                isLoading: false,
                docId: undefined
            }
        },
        props: {
            dynamicId: {
                type: String,
                required: true
            },
            instance: {
                type: String,
                required: true
            },
            keyId: {
                type: String,
                required: true
            },
            exportData: {
                required: true
            },
            url: {
                required: true
            },
            buttonUrl: {
                type: String,
                required: true
            },
            blobType: {
                type: String,
                required: false,
                default: 'application/zip'
            },
            fileName: {
                type: String,
                required: true
            },
            errorText: {
                type: String,
                required: false
            },
            downloadingText: {
                type: String,
                required: false
            },
            readyText: {
                type: String,
                required: false
            }
        },
        async mounted() {
            await this.fnExcelExportation()
        },
        methods: {
            async fnExcelExportation() {
                let loader = this.$loading.show({ container: this.$refs["divloading" + this.keyId], isFullPage: false });
                let data = this.exportData
                axios
                    .post(this.url, data)
                    .then(response => {
                        this.docId = response.data.fileName
                        this.successUrl = window.URL.createObjectURL(new Blob([response.data], { type: response.data.contentType }));
                        this.successFile = true
                        this.downloadAndClose()
                    loader.hide({ container: this.$refs["divloading" + this.keyId] })
                }).catch((exception) => {
                    loader.hide({ container: this.$refs["divloading" + this.keyId] })
                    this.excelError = true;
                });



            },
            close() {
                this.$store.dispatch("removeWidgetCard", this.keyId);
            },
            downloadAndClose() {
                axios({
                    url: this.buttonUrl + this.docId, //your url
                    method: 'GET',
                    responseType: 'blob' // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'FilesDownloaded.zip'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
                this.$store.dispatch("removeWidgetCard", this.keyId);
            }
        }
    }
</script>

<style>
</style>